export { generateFingerprint, getFingerprint } from "./fingerprintService";
